import { useState } from "react";
import "./Navbar.mobile.css";
import "./Navbar.css";

const LINKS = [
  { id: "accueil", label: "Accueil", href: "/" },
  { id: "blog",    label: "Blog",    href: "/blog" },
  { id: "contact", label: "Contact", href: "/contact" },
];

// Détermine le lien actif depuis window.location.pathname
const getActiveId = () => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  if (path.startsWith("/blog"))    return "blog";
  if (path.startsWith("/contact")) return "contact";
  return "accueil";
};

const NavLink = ({ link, isActive, onClick }) => (
  <a
    href={link.href}
    className={`navbar-link${isActive ? " navbar-link--active" : ""}`}
    aria-current={isActive ? "page" : undefined}
    onClick={onClick}
  >
    <span className="navbar-link-label">{link.label}</span>
    <span className="navbar-link-marker" aria-hidden="true" />
  </a>
);

const Navbar = () => {
  const [activeId, setActiveId] = useState(getActiveId);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = (id) => {
    setActiveId(id);
    setMenuOpen(false);
  };

  return (
    <nav className="navbar-root" role="navigation" aria-label="Navigation principale">

      {/* ── Identité ── */}
      <a href="/" className="navbar-brand" onClick={() => handleLinkClick("accueil")}>
        <span className="navbar-brand-name">Dimitri Youla</span>
        <span className="navbar-brand-role">Designer · Dev</span>
      </a>

      {/* ── Desktop : liens directs ── */}
      <div className="navbar-links-desktop" role="list">
        {LINKS.map((link) => (
          <NavLink
            key={link.id}
            link={link}
            isActive={activeId === link.id}
            onClick={() => handleLinkClick(link.id)}
          />
        ))}
      </div>

      {/* ── Mobile : burger ── */}
      <button
        className={`navbar-burger${menuOpen ? " navbar-burger--open" : ""}`}
        aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={menuOpen}
        aria-controls="navbar-mobile-menu"
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span className="navbar-burger-bar" />
        <span className="navbar-burger-bar" />
        <span className="navbar-burger-bar" />
      </button>

      {/* ── Mobile : menu déroulant ── */}
      <div
        id="navbar-mobile-menu"
        className={`navbar-mobile-menu${menuOpen ? " navbar-mobile-menu--open" : ""}`}
        aria-hidden={!menuOpen}
      >
        {LINKS.map((link) => (
          <NavLink
            key={link.id}
            link={link}
            isActive={activeId === link.id}
            onClick={() => handleLinkClick(link.id)}
          />
        ))}
      </div>

    </nav>
  );
};

export default Navbar;